import { RootState } from "../..";

export const selectContactUsIsLoading = (state: RootState) => state.contactUs.contactUsIsLoading;

export const selectContactUsErrorMessage = (state: RootState) => state.contactUs.contactUsErrorMessage;

export const ContactUsFormData = (state: RootState) => state.contactUs.contactUsFormData;
